module.exports = __webpack_public_path__ + "static/media/intel-link.702d3df3.svg";